
export default function routes($stateProvider) {
	$stateProvider
		.state('preferencesPage', {
			url: '/preferences',
			template: require('./preferences.html'),
			resolve: {
				loggedIn: ['User', function (User) {
					return User.requireLogin();
				}],
				brand: ['Brand', function (Brand) {
					return Brand.get();
				}],
				marketer: ['Marketer', function (Marketer) {
					return Marketer.me();
				}],
			},
			controller: 'PreferencesController',
			controllerAs: 'preferences',
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/preferences/preferences.routes.js